export function getProductSourceInspectSourceId(
  pathname: string,
  productId: string
): string | undefined {
  const prefix = `/product-catalog/${productId}/sources/`
  if (!pathname.startsWith(prefix)) {
    return undefined
  }

  const remainder = pathname.slice(prefix.length)
  const sourceId = remainder.split('/')[0] ?? ''
  if (sourceId.length === 0) {
    return undefined
  }

  return sourceId
}

export function getProductDetailPath(productId: string): string {
  return `/product-catalog/${productId}`
}
